// import { baseRoute } from '../../../../constants/routes'

// export const TEXT_QUESTIONS_ROUTE = baseRoute + '/text-questions'
// export const TEXT_ANSWERS_ROUTE = baseRoute + '/text-answers'

// export const CREATE_TEXT_QUESTION = 'CREATE_TEXT_QUESTION'
// export const CREATE_TEXT_QUESTION_SUCCESS = 'CREATE_TEXT_QUESTION_SUCCESS'
   export const CREATE_TEXT_ANSWER_SUCCESS = 'CREATE_TEXT_ANSWER_SUCCESS'